export default __webpack_public_path__ + "static/media/Offering Solutions Software.8aaccfe7.png";